<div class="row">
  <div class="caption-container">
    <span class="caption-name">{{ this.vdevGroup.group | translate }}</span>
  </div>
  <div class="toggle-container">
    <ng-content></ng-content>
  </div>
</div>
